<div
  class="circular-progress__container"
  [ngClass]="{
    '--sm': size === 'sm',
    '--success': value >= 100 && !disableCheckSymbol,
  }"
  [style.--circular-progress-value]="value"
  [style.--circular-progress-diameter]="diameter"
  [style.--circular-progress-cutout-diameter]="cutoutDiameter"
  matTooltip="{{ value | number: '1.0-0' }}%"
  [matTooltipDisabled]="size != 'sm'"
>
  <span class="circular-progress__label">{{
    displayValue ? displayValue : (value | number: '1.0-0') + '%'
  }}</span>

  @if (!disableCheckSymbol) {
    <mat-icon class="circular-progress__icon-complete">check_small</mat-icon>
  }
</div>
